import React, {Component} from 'react';
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../utilities/TabGrid";

export default class OcenyKierowcowTable extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount(){
    }


    renderGwiazdki(cell,row){
        if(Boolean(cell)){
            let procent = (cell*100)/5
            return(
                <div>
                <div className="stars-outer">
                    <div className="stars-inner" style={{width: procent+'%'}}></div>
                </div>
                    <span style={{color:'grey',marginLeft:'15px', fontStyle:'italic'}}>
                    {cell}
                    </span>
                </div>
            )
        }
    }

    render() {

        const options = {
            defaultSortName: 'ogolem',
            sortOrder: 'desc',
        }

        return (
            <div>
                <BootstrapTable data={this.props.data}
                                options={options}
                                hover
                >

                    <TableHeaderColumn dataField='idOk' isKey hidden={true}>ID Oceny</TableHeaderColumn>
                    <TableHeaderColumn dataField='kierowca' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={{type: 'TextFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Kierowca</TableHeaderColumn>
                    <TableHeaderColumn dataField='ilosc' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                    >Ilość ocen</TableHeaderColumn>
                    <TableHeaderColumn dataField='ocena1' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={this.renderGwiazdki}
                    >Średnio czystość</TableHeaderColumn>
                    <TableHeaderColumn dataField='ocena2' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={this.renderGwiazdki}
                    >Średnio komfort</TableHeaderColumn>
                    <TableHeaderColumn dataField='ocena3' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={this.renderGwiazdki}
                    >Średnio kierowca</TableHeaderColumn>
                    <TableHeaderColumn dataField='ocena4' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={this.renderGwiazdki}
                    >Średnio punktualność</TableHeaderColumn>
                    <TableHeaderColumn dataField='ogolem' dataSort
                                       thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2}
                                       filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                       dataFormat={this.renderGwiazdki}
                    >Średnia ogółem</TableHeaderColumn>
                </BootstrapTable>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/klienciConfig/oceny/components/OcenyKierowcowTable.js